export default {
	tenantId: "apex_uat",
	appId: "covergo_crm",

	fileSystem: {
		bucketName: "apex--uat"
	}
}
